// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-iGB","footer":"styles_footer__dUBms","passCodeTooltip":"styles_passCodeTooltip__310yd"};